import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// جلب اللغة المحفوظة من localStorage أو استخدام اللغة الافتراضية
const savedLanguage = localStorage.getItem('preferred-language');
const lng = savedLanguage || 'de';

// تعيين اتجاه الصفحة بناءً على اللغة
document.dir = lng === 'ar' ? 'rtl' : 'ltr';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: lng,
        fallbackLng: 'de',
        supportedLngs: ['en', 'ar', 'de'],
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },
        react: {
            useSuspense: true,
        }
    });

// تعديل دالة changeLanguage الأصلية في i18n لحفظ التفضيلات
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);

i18n.changeLanguage = (lng, options) => {
    return originalChangeLanguage(lng, options).then(() => {
        localStorage.setItem('preferred-language', lng);
        document.dir = lng === 'ar' ? 'rtl' : 'ltr';
    });
};

export default i18n;